import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/support_teams/index.vue') }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/support_teams/new.vue') }
}

export class EditController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/admin/support_teams/edit.vue') }

  static values = {
    teamId: String
  }

  connect() {
    super.connect({
      teamId: this.teamIdValue
    })
  }
}

